import { useState } from 'react';
import { Alert, AlertTitle, Button, IconButton, InputAdornment, Stack } from '@mui/material';
import useAuth from 'src/hooks/useAuth';
import Iconify from 'src/components/Iconify';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FormProvider, RHFTextField } from 'src/components';

// ----------------------------------------------------------------------

const defaultValues = {
  username: '',
  password: '',
};
export function LoginForm() {
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const loginSchema = Yup.object().shape({
    username: Yup.string().required('نام کاربری را وارد کنید'),
    password: Yup.string().required('رمز عبور را وارد کنید').min(6, 'رمز عبور حداقل باید شش حرف باشد'),
  });

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(loginSchema),
  });
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      await login(data.username, data.password);
    } catch (error) {
      if (error.response.data.key === 'err.user.authLoginWrongCredentials') {
        setError('نام کاربری یا رمز عبور اشتباه است.');
        return;
      }
      setError(error);
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      {error?.response?.data?.message !== undefined ||
        error.message ||
        (error && (
          <Alert severity="error" sx={{ my: 2 }}>
            <AlertTitle>{error?.response?.data?.message || error.message || error}</AlertTitle>
          </Alert>
        ))}
      <Stack sx={{ width: 500 }}>
        <RHFTextField label="نام کاربری" name="username" sx={{ my: 1 }} />
        <RHFTextField
          label="رمز عبور"
          name="password"
          type={showPassword ? 'text' : 'password'}
          sx={{ my: 1 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-off-fill' : 'eva:eye-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button size="large" variant="contained" type="submit" disabled={isSubmitting} sx={{ color: 'white', my: 1 }}>
          ورود
        </Button>
      </Stack>
    </FormProvider>
  );
}
